import React, { useRef, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import { styled } from "@mui/system";
import { CardHeader } from "@mui/material";

// Mapping for payment period codes
const paymentPeriodMap = {
  M: "รายเดือน",
  U: "รายสามเดือน",
  S: "รายหกเดือน",
  A: "รายปี",
};

// Function to translate payment period codes to Thai
const translatePaymentPeriod = (period) => {
  if (!period) return "-";
  if (Array.isArray(period)) {
    return period.map((p) => paymentPeriodMap[p] || p).join(", ");
  }
  return paymentPeriodMap[period] || period;
};

const ScrollableModePay = ({
  policiesData,
  setPoliciesData,
  listData,
  inputData,
  setListData,
  mobilePhone,
  onSelectionChange, // Add new prop to notify parent of selection changes
}) => {
  const cardRef = useRef(null);
  const [selectedIndexes, setSelectedIndexes] = useState([]); // เก็บ index ของ Box ที่ถูกเลือกเป็น array

  useEffect(() => {
    // console.log(inputData)
    const selectedIndexList = listData.map((item) => item.index); // ดึง index จาก listData
    setSelectedIndexes(selectedIndexList);
    console.log(policiesData)
    // console.log("cardRef.current:", cardRef.current);
  }, [policiesData]); // เรียกครั้งเดียวหลัง

  // Notify parent component when selection changes
  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(selectedIndexes.length > 0);
    }
  }, [selectedIndexes, onSelectionChange]);

  const CustomCheckbox = styled(Checkbox)({
    color: "rgba(255, 94, 67, 0.5)",
    "&.Mui-checked": {
      color: "#FF5E43",
    },
    marginRight: "15px",
  });

  const handleBoxClick = (index, policy_no, currentMode,baseName) => {
    console.log("handleBoxClick => " + policy_no);
    setSelectedIndexes((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        // ถ้าถูกเลือกแล้ว ให้ลบออกจาก array
        // console.log(policy_no)
        removeItemByPolicyNo(policy_no);
        return [];
      } else {
        // ถ้ายังไม่ถูกเลือก ให้เคลียร์ทั้งหมดก่อนแล้วเลือกเฉพาะอันนี้
        removeAllItems(); // เคลียร์ทุกรายการที่เลือกไว้ก่อนหน้า

        // Get the selected item from policiesData
        const selectedItem = policiesData[index];

        const updatedList = {
          index: index,
          policy_no: policy_no,
          currentMode: currentMode,
          changeMode: "",
          baseName: baseName
        };
        console.log("updatedList with changePaymentModePeriod:", updatedList);

        addItem(updatedList);
        return [index]; // เก็บเฉพาะ index ที่เลือกล่าสุด
      }
    });
  };

  const addItem = (newItem) => {
    setListData((prevListData) => [...prevListData, newItem]);
  };

  const removeItemByPolicyNo = (policyNo) => {
    setListData((prevListData) =>
      prevListData.filter((item) => item.policy_no !== policyNo)
    );
  };

  const removeAllItems = () => {
    setListData([]); // ตั้งค่า listData ให้เป็น array ว่าง
    setSelectedIndexes([]); // เคลียร์ selectedIndexes
  };

  return (
    <Card
      ref={cardRef}
      sx={{
        maxHeight: "490px",
        overflowY: "auto",
        borderRadius: "12px",
        border: "1px solid rgba(255, 94, 67, 0.3) !important", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
        borderWidth: "2px !important",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        width: "100%", // เพิ่มความกว้างให้เต็ม 100%
      }}
    >
      <CardContent
        sx={{
          maxHeight: "490px",
          overflowY: "auto",
          cursor: "pointer",
          boxSizing: "border-box",
        }}
      >
        {console.log("policiesData:", policiesData)}
        {policiesData && policiesData.length > 0 ? (
          policiesData.map((_, index) => {
            console.log("Item at index", index, ":", _);
            console.log(
              "changePaymentModePeriod:",
              _.changePaymentModePeriod || _.change_payment_mode_period
            );
            return (
              <Box
                key={index}
                onClick={() =>
                  handleBoxClick(
                    index,
                    _.policy_no || _.policyNo,
                    _.policyPaymentMode,
                    _.base_name || _.baseName
                  )
                }
                sx={{
                  marginBottom: "15px",
                  padding: "10px",
                  transition: "background-color 0.3s ease, border 0.3s ease",
                  cursor: "pointer",
                  alignItems: "center", // จัดให้ทุกอย่างอยู่กึ่งกลางในแนวตั้ง
                  justifyContent: "space-between", // แยกข้อความทางซ้ายกับไอคอนทางขวา
                }}
              >
                <Card
                  style={{ zIndex: 1000 }}
                  sx={{
                    backgroundColor: selectedIndexes.includes(index)
                      ? "rgba(255, 94, 67, 0.1)" // สีพื้นหลังเข้มเมื่อถูกเลือก
                      : "transparent", // พื้นหลังปกติ
                    transition: "background-color 0.3s ease, border 0.3s ease",
                    border: "1px solid rgba(255, 94, 67, 0.3) !important", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
                    borderRadius: "12px !important", // ความโค้งของขอบ
                    borderWidth: "2px !important",
                  }}
                >
                  <CardHeader
                    title={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <CustomCheckbox
                          checked={selectedIndexes.includes(index)} // ทำการเช็คตาม selectedIndexes
                          onChange={(e) => {
                            console.log(e);
                            e.stopPropagation();
                          }}
                          sx={{ color: "rgba(255, 94, 67, 0.8)" }} // ปรับสี
                        />
                        <Stack spacing={1}>
                          <Box sx={{ marginLeft: "10px" }}>
                            {"กรมธรรม์เลขที่ : " + (_.policy_no || _.policyNo)}
                          </Box>
                          <Box sx={{ marginLeft: "10px" }}>
                            {"ชื่อแบบประกัน : " +
                              (_.baseName || _.base_name || "")}
                          </Box>
                        </Stack>
                      </Box>
                    }
                    sx={{
                      backgroundColor: "rgba(255, 94, 67, 0.3)", // ปรับให้ใช้งาน rgba ถูกต้อง
                    }}
                    titleTypographyProps={{
                      sx: {
                        fontFamily: '"Prompt-Thin", sans-serif !important',
                        fontSize: "15px",
                        color: "black",
                        marginLeft: "15px",
                      },
                    }}
                  />
                  <CardContent>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs="auto">
                        <span className="font-size-label-pol">
                          งวดการชำระเบี้ยปัจจุบัน :
                        </span>
                      </Grid>
                      <Grid item xs="auto">
                        <span style={{fontWeight:"bold"}} className="font-size-label-pol">
                        {_.policyPaymentMode}
                        </span>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Box></Box>
              </Box>
            );
          })
        ) : (
          <Box sx={{ textAlign: "center", padding: "20px", width: "100%" }}>
            <Typography
              variant="h6"
              sx={{ color: "#666", fontFamily: '"Prompt-Thin", sans-serif' }}
            >
              ไม่พบข้อมูล
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ScrollableModePay;
